<template>
  <!-- autocompelete input -->
  <div class="auto-compelete-input">
    <vue-tribute :options="{ ...options, values }">
      <div
        class="form-control h-auto"
        contentEditable="true"
        ref="textInput"
        data-placeholder="enter value..."
        v-html="text"
        @input="onInput"
        @keydown="onKeyDown"
        @paste="onPaste"
      ></div>
    </vue-tribute>
  </div>
</template>

<script>
import VueTribute from "vue-tribute";

export default {
  components: {
    VueTribute,
  },
  props: {
    items: Array,
    value: String,
    rejectKeys: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      text: this.value,
      options: {
        trigger: "[",
        selectTemplate: (item) => {
          return `<mark class='mx-1 mention' contenteditable='false' readonly>[${item.original.value}]</mark>`;
        },
        positionMenu: true,
        menuContainer: document.querySelector(".menu-container"),
        requireLeadingSpace: false,
        replaceTextSuffix: "",
      },
    };
  },
  computed: {
    values() {
      return this.items.map((item) => ({
        key: item.text || item,
        value: item.value || item,
      }));
    },
    parsedValue() {
      return this.parseValue(this.text);
    },
  },
  mounted() {
    this.options.menuContainer = this.$refs.menuContainer;
    this.text = this.parsedValue;
  },
  methods: {
    parseValue(value) {
      return value
        .replaceAll(
          "[",
          `<mark class='mx-1 mention' contenteditable='false' readonly>[`
        )
        .replaceAll("]", `]</mark>`);
    },
    onInput(evt) {
      const value = evt.target.innerText;
      this.$emit("input", value);
    },
    onKeyDown(evt) {
      if (this.rejectKeys.includes(evt.key)) {
        evt.preventDefault();
      }
    },
    onPaste(evt) {
      evt.preventDefault();
      const text = evt.clipboardData
        .getData("text/plain")
        .replaceAll("\n", "")
        .replaceAll(" ", "");
      document.execCommand("insertText", false, text);
    },
  },
};
</script>

<style lang="scss">
.auto-compelete-input {
  .scroll {
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    position: relative;
  }
  .container {
    max-width: 355px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 20px;
  }
  .v-tribute {
    width: 100%;
    position: relative;
  }
  input[type="text"],
  .content-editable {
    appearance: none;
    border: none;
    background: #eee;
    padding: 1rem 1rem;
    color: #666;
    width: 100%;
    border-radius: 0.25rem;
    font-size: 16px;
    outline: none;
    &:focus {
      background: #fff;
    }
  }
  .content-editable:empty:before {
    content: attr(placeholder);
    display: block;
    color: #666;
  }
  textarea {
    appearance: none;
    border: none;
    background: #eee;
    padding: 1rem;
    width: 100%;
    border-radius: 0.25rem;
    font-size: 16px;
    height: 100px;
    outline: none;
    &:focus {
      background: #fff;
    }
  }
  .btn {
    appearance: none;
    border: none;
    cursor: pointer;
    margin: 20px 0;
    background: #fc466b;
    color: #fff;
    font-size: 16px;
    padding: 8px 16px;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(#000, 0.18);
    &:hover {
      background: darken(#fc466b, 3%);
    }
  }
  .mention {
    background-color: #4a7dff;
    color: #fff !important;
  }
  [data-placeholder]:empty:before {
    content: attr(data-placeholder);
    color: #888;
    font-style: italic;
  }
}
// Tribute-specific styles
.tribute-container {
  position: absolute;
  top: 0;
  left: 0;
  height: auto;
  max-height: 300px;
  max-width: 500px;
  overflow: auto;
  display: block;
  z-index: 999999;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(#000, 0.13);
  ul {
    margin: 0;
    margin-top: 2px;
    padding: 0;
    list-style: none;
    background: #fff;
    border-radius: 4px;
    border: 1px solid rgba(#000, 0.13);
    background-clip: padding-box;
    overflow: hidden;
  }
  li {
    color: #6993ff;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 14px;
  }
  li.highlight,
  li:hover {
    background: #6993ff;
    color: #fff;
  }
  li span {
    font-weight: bold;
  }
  li.no-match {
    cursor: default;
  }
  .menu-highlighted {
    font-weight: bold;
  }
}
</style>
